var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubebee15F9B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    background: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 6.04995C11.7 5.69995 11.45 5.44995 11.1 5.34995C10.5 5.19995 7.95 5.19995 7.95 5.19995C7.95 5.19995 5.45 5.19995 4.8 5.34995C4.45 5.44995 4.2 5.69995 4.1 6.04995C4 6.69995 4 7.99995 4 7.99995C4 7.99995 4 9.29995 4.15 9.94995C4.25 10.3 4.5 10.55 4.85 10.65C5.45 10.8 8 10.8 8 10.8C8 10.8 10.5 10.8 11.15 10.65C11.5 10.55 11.75 10.3 11.85 9.94995C12 9.29995 12 7.99995 12 7.99995C12 7.99995 12 6.69995 11.8 6.04995ZM7.2 9.19995V6.79995L9.3 7.99995L7.2 9.19995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubebee15F9B);
export default __webpack_public_path__ + "static/media/youtube.bee15f9b.2d28551e1e28ef1292fa41e241f98bc8.svg";
export { ForwardRef as ReactComponent };